import AvFilterManager from './AvFilterManager'

angular.module("avlib").directive("avTablePanel", function(){
	return {
		template: require("!html-loader!./TablePanelTemplate.html"),
		restrict: "E",
		scope: {
			data:'=',
			tableData:'=?filteredData',
			tableModel:'=',
			sortModel:'=',
			selectionModel:"=",
			paginationModel:"=",
			barActions:'=',
			dropdownActions:"=",
			perspecManager:"=",
			textFilter:"=",
			perspecFilter:"=",
			buttonFilters:"=",
			panelConfig:"=",
		},
		
		controller: ["$scope", "$filter", function($scope, $filter){
			
			if (Array.isArray($scope.data)){
				$scope.tableData = [].concat($scope.data);				
			}

			var pageSize = $scope.panelConfig.pageSize == undefined ? 5 :  $scope.panelConfig.pageSize;

			/**
			 * Modelo de dados para controlar a paginação dos itens da tabela.
			 */
			$scope.paginationModel = {
				currentPage: 0,
				pageSize: pageSize,
				pageCount: 0,
				itemCount: 0,
			};
			
		   	$scope.selectionModel = {
		   			
	   	   		selectedData: [],
	   	   			
	   	   		// Indica quando a checkbox de seleção de todos os itens encontra-se selecionada na interface
	   	   		checkboxAllSelected: false,
	   	   		// Quantidade total de itens selecionados no momento
	   	   		selectionCount: 0,

	   	   		selectAllChanged: function(selectAll){
	   	   			this.updateSelectionCount();
	   	   		},

	   	   		clearSelection: function(){
	   	   			this.checkboxAllSelected = false;
	   	   			this.selectionCount = 0;
					if ($scope.data){
		   	   			$scope.data.forEach(function (item){
		   	   				item.selected = false; 
		   	   			});
					}
	   	   		},
	   	   		
	   	   		updateSelectionCount: function(){
	   	   			$scope.selectionModel.selectionCount = 0;
	   	   			$scope.data.forEach(function (item){
	   	   				if (item.selected) $scope.selectionModel.selectionCount++; 
	   	   			});			
	   	   		}
	   	   	};			
			
	   	   	if ($scope.panelConfig.tableConfig){
	   	   		$scope.tableConfig = $scope.panelConfig.tableConfig;
	   	   	}

			var allFilters = [$scope.textFilter];
			if ($scope.perspecFilter){
				allFilters = allFilters.concat($scope.perspecFilter);
			}
			allFilters = allFilters.concat($scope.buttonFilters);

			$scope.filterChanged = function(){
				$scope.filterManager.apply();
			};

			$scope.switchPerspective = function(perspecId){
				$scope.perspecManager.activatePerspective(perspecId);
				$scope.selectionModel.clearSelection();
				$scope.filterManager.apply();
			};
			
			$scope.createFilterSummary = function(filter){
				switch (filter.type){
					case "buttonFilter":
						if (filter.selection.length)
							return "("+filter.selection.length+")";
						break;
					case "dateFilter":
						if (filter.fromDate || filter.byDate){
							return "("+
									(filter.fromDate ? $filter("date")(filter.fromDate, "dd/MM") : "?")+
									" - "+
									(filter.byDate ? $filter("date")(filter.byDate, "dd/MM") : "?")+
									")";
						}
						break;
				}
				return "";
			};

			$scope.$watch("data", function(){
				if (Array.isArray($scope.data)){
					$scope.tableData = [].concat($scope.data);
					$scope.filterManager = new AvFilterManager(allFilters, $scope.data, $scope.tableData);
					$scope.filterManager.apply();
					$scope.selectionModel.updateSelectionCount();
				}
			}, true);
		}],
	};
});
